export default {
  title: 'Google-arvosteluohjelma',
  sections: {
    google_review_settings: 'Google-arvosteluohjelman asetukset',
  },
  form: {
    reward: {
      label: 'Palkkio (pisteet)',
      point_value: '100 pistettä = {{moneyValue}}',
    },
    has_end_date: {
      label: 'Kesto',
      options: {
        false: 'Rajoittamaton',
        true: 'Tietyllä päättymispäivällä',
      },
    },
    end_date: {
      label: 'Päättymispäivä',
    },
  },
  tags: {
    inactive: 'Ei aktiivinen',
    active: 'Aktiivinen',
    expired: 'Vanhentunut',
  },
  buttons: {
    save: 'Tallenna',
  },
  toasts: {
    failed_to_load_data: 'Tietojen lataaminen epäonnistui',
    changes_got_saved: 'Muutokset tallennettu',
    failed_to_save_changes: 'Muutosten tallentaminen epäonnistui',
  },
};
